<h1 *ngIf="last" class="not-found">Page Not Found</h1>